import { render, staticRenderFns } from "./EquivalenceInfo.vue?vue&type=template&id=7d5ddf9e"
import script from "./EquivalenceInfo.vue?vue&type=script&lang=js"
export * from "./EquivalenceInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports